import DefaultParameters from './DefaultParameters';
import DefaultQuote from './DefaultQuote';
import DefaultSuppliers from './DefaultSuppliers';

import { START } from 'pu-data/QuoteSteps';
import { USA_PCB_ASSEMBLY_ID } from './productVariants';

const state = {
  loading: false,
  parameters: DefaultParameters,
  parametersChanged: false,
  suppliers: DefaultSuppliers,
  quote: DefaultQuote,
  quoteStep: START,
  currentVariant: USA_PCB_ASSEMBLY_ID,
  destroy: false,
  lineItemId: null,
  zip_file_input_id: null,
  quantitiesChanged: false,
}

export default state;